import React from 'react'
import Footer from '../Components/Footer'
import HeroImage from '../Components/HeroImage'
import WorkCard from '../Components/WorkCard'

const Project = () => {
  return (
    <>
     <HeroImage heading="PROJECTS." text="Some of My Most Recent Works"/>
     <WorkCard/>
     <Footer/>
     </>
  )
}

export default Project